'use strict';

export const einsteinCarousel = initCarouselFunc => {
    const config = {attributes: true, childList: true, subtree: true};

    const callback = (mutations, observer) => {
        initCarouselFunc();

        observer.disconnect();
    };

    $('[id^=cq_recomm_slot]').each((i, slot) => {
        const observer = new MutationObserver(callback);

        observer.observe(slot, config);
    });
};
